<template>
  <button class="bg-olive p-3">
    <slot />
  </button>
</template>